<template>
  <div class="h-100">
    <toastification-loading-content ref="loadingToast"/>
    <div
      class="d-flex justify-content ml-2 align-items-center my-2"
      v-if="source === 'default'"
    >
      <button
        class="btn btn-sm rounded-circle p-25 cursor-pointer"
        :class="isDark ? 'btn-danger' : 'btn-primary'"
        @click="goBack()"
      >
        <i class="feather icon-arrow-left arrow-icon"></i>
      </button>
      <div
        class="ml-1 text-capitalize text-dark cursor-pointer goback-text"
        @click="goBack()"
      >
        {{ $t("go_back") }}
      </div>
    </div>
    <b-card
      :class="{
        'm-2 p-2': source === 'default',
        'm-0 shadow-none showScroll': source !== 'default',
      }"
      no-body
    >
      <b-row
        class="justify-content-between mb-2 mx-0 align-items-center"
        :class="{ 'my-1': source !== 'default' }"
      >
        <b-col cols="6" v-if="source === 'default'">
          <div class="d-flex align-items-center">
            <h4 v-if="panel.id" class="mb-0">{{ panel.name }}</h4>
          </div>
        </b-col>
        <b-col
          :cols="source === 'default' ? 6 : 12"
          :class="{ 'px-0': source !== 'default' }"
        >
          <div class="d-flex align-items-center justify-content-end">
            <b-form-input
              v-model="textFilter"
              :placeholder="$t('table.search')"
              class="mr-1"
              :class="{ 'form-control-sm': source !== 'default' }"
            />
            <b-button
              variant="primary"
              @click="syncDevices()"
              :disabled="loading"
              :class="{ 'btn-sm': source !== 'default' }"
              v-if="$can('sync_devices', 'BoschPanel')"
            >
              <span class="text-nowrap text-capitalize">
                {{ $t("bosch.syncDevices") }}
              </span>
            </b-button>
          </div>
        </b-col>
      </b-row>

      <!-- Heading table -->
      <div :class="{ 'container-fluid': source === 'default' }">
        <b-row class="text-muted p-1 mx-0 table-fields-devices">
          <b-col class="table-title">ACCIONES</b-col>
          <b-col class="table-title">ESTADO</b-col>
          <b-col class="table-title">TIPO</b-col>
          <b-col class="table-title">NOMBRE</b-col>
          <b-col class="table-title">ID DE DISPOSITIVO</b-col>
        </b-row>
        <!-- Main panel with your actions -->
        <div v-if="panel.devices && panel.devices.panel && showPanel" class="device-row border-bottom">
          <b-row
            class="align-items-center px-2 py-1"
            :class="{ 'px-1': source !== 'default' }"
          >
            <b-col>
              <bosch-panel
                :device="panel.devices.panel"
                :trans="trans"
                :loadingToast="loadingToast"
                :updateStatus="updateStatus"
                :timeout="refreshTimeout"
                class="d-flex"
                :class="{
                  'align-items-start': source !== 'default',
                }"
              />
            </b-col>
            <b-col>
              <span :class="getStatusClass(panel.devices.panel.status, 'panel')">
                {{ panel.devices.panel.status }}
              </span>
            </b-col>
            <b-col>{{ panel.devices.panel.device_type.toUpperCase() }}</b-col>
            <b-col>{{ panel.devices.panel.text }}</b-col>
            <b-col>{{ panel.devices.panel.device_id }}</b-col>
          </b-row>
        </div>

        <!-- Area accordion -->
        <div v-if="panel.devices && panel.devices.areas" class="">
          <div
            v-for="area in filteredAreas"
            :key="`area-${area.id}`"
            class="area-accordion"
          >
            <!-- Area header (clickable) -->
            <div
              class="area-header device-row cursor-pointer"
              @click="toggleArea(area.id)"
              :class="{ 'area-expanded': expandedAreas.includes(area.id) }"
            >
              <b-row class="align-items-center p-2">
                <b-col class="pr-0">
                  <div class="d-flex align-items-center">
                    <i
                      class="feather mr-1 transition-all"
                      :class="
                        expandedAreas.includes(area.id)
                          ? 'icon-chevron-down'
                          : 'icon-chevron-right'
                      "
                    ></i>
                    <bosch-area
                      :device="area"
                      :trans="trans"
                      :loadingToast="loadingToast"
                      :updateStatus="updateStatus"
                      :timeout="refreshTimeout"
                    />
                  </div>
                </b-col>
                <b-col>
                  <span :class="getStatusClass(area.status)">
                    {{ area.status }}
                  </span>
                </b-col>
                <b-col>{{ area.device_type.toUpperCase() }}</b-col>
                <b-col>{{ area.text }}</b-col>
                <b-col>{{ area.device_id }}</b-col>
              </b-row>
            </div>

            <!-- Collapsible content with the areas zones -->
            <b-collapse :visible="expandedAreas.includes(area.id)" class="area-content">
              <div class="zones-container border-left">
                <div
                  v-for="zone in area.devices"
                  :key="`zone-${zone.id}`"
                  class="device-row zone-row border-bottom"
                >
                  <b-row class="align-items-center p-2">
                    <b-col>
                      <bosch-zone
                        :device="zone"
                        :trans="trans"
                        :loadingToast="loadingToast"
                        :updateStatus="updateStatus"
                        :timeout="refreshTimeout"
                      />
                    </b-col>
                    <b-col>
                      <!--
                      Note: old zone status replaced by new using zone.bypass_text
                      <span :class="getStatusClass(zone.status)">
                        {{ zone.status }}
                      </span>
                      -->
                      <span class="mt-2" :class="getStatusClass(zone.bypass_text)">
                        {{ zone.bypass_text }}
                      </span>   
                    </b-col>
                    <b-col>{{ zone.device_type.toUpperCase() }}</b-col>
                    <b-col>{{ zone.text }}</b-col>
                    <b-col>{{ zone.device_id }}</b-col>
                  </b-row>
                </div>
              </div>
            </b-collapse>
          </div>
        </div>

        <!-- Independent outputs -->
        <div
          v-if="
            panel.devices && panel.devices.outputs && panel.devices.outputs.length > 0
          "
          class=""
        >
          <div
            v-for="output in filteredOutputs"
            :key="`output-${output.id}`"
            class="device-row border-bottom"
          >
            <b-row class="align-items-center p-2">
              <b-col>
                <bosch-output
                  :device="output"
                  :trans="trans"
                  :loadingToast="loadingToast"
                  :updateStatus="updateStatus"
                  :timeout="refreshTimeout"
                />
              </b-col>
              <b-col>
                <span :class="getStatusClass(output.status)">
                  {{ output.status }}
                </span>
              </b-col>
              <b-col>{{ output.device_type.toUpperCase() }}</b-col>
              <b-col>{{ output.text }}</b-col>
              <b-col>{{ output.device_id }}</b-col>
            </b-row>
          </div>
        </div>

        <!-- Independent doors -->
        <div
          v-if="
            panel.devices && panel.devices.doors && panel.devices.doors.length > 0
          "
          class=""
        >
          <div
            v-for="door in filteredDoors"
            :key="`door-${door.id}`"
            class="device-row border-bottom"
          >
            <b-row class="align-items-center p-2">
              <b-col>
                <bosch-door
                  :device="door"
                  :trans="trans"
                  :loadingToast="loadingToast"
                  :updateStatus="updateStatus"
                  :timeout="refreshTimeout"
                />
              </b-col>
              <b-col>
                <span :class="getStatusClass(door.status)">
                  {{ door.status }}
                </span>
              </b-col>
              <b-col>{{ door.device_type.toUpperCase() }}</b-col>
              <b-col>{{ door.text }}</b-col>
              <b-col>{{ door.device_id }}</b-col>
            </b-row>
          </div>
        </div>
      </div>
    </b-card>
  </div>
</template>

<script>
import {BRow, BCol, BFormInput, BTable, BCollapse, BButton} from "bootstrap-vue";
import {
  computed,
  ref,
  watch,
  onMounted,
  getCurrentInstance,
  onBeforeUnmount,
} from "@vue/composition-api";
import {useUtils as useI18nUtils} from "@core/libs/i18n";
import {useToast} from "vue-toastification/composition";
import ToastificationLoadingContent
  from "@core/components/toastification/ToastificationLoadingContent.vue";
import ToastificationContent
  from "@core/components/toastification/ToastificationContent.vue";
import router from "@/router";
import store from "@/store";
import BoschPanel from "./BoschPanel.vue";
import BoschArea from "./BoschArea.vue";
import BoschZone from "./BoschZone.vue";
import BoschOutput from "./BoschOutput.vue";
import BoschDoor from "./BoschDoor.vue";

export default {
  name: "BoschDevices",
  components: {
    BoschPanel,
    BoschOutput,
    BoschZone,
    ToastificationLoadingContent,
    BoschArea,
    BoschDoor,
    BRow,
    BCol,
    BFormInput,
    BTable,
    BCollapse,
    BButton,
  },
  props: {
    panelId: Number | String,
    source: {
      type: String,
      default: "default",
    },
  },
  setup(props) {
    // COMPOSABLES
    const {t, tc} = useI18nUtils();
    const toast = useToast();

    // DATA
    const loading = ref(false);
    const panel = ref({});
    const bTable = ref(null);
    const textFilter = ref("");
    const loadingToast = ref(null);
    const checkStatusInterval = ref(null);
    const expandedAreas = ref([]);
    const refreshTimeout = 4 * 1000;

    // HOOKS
    onMounted(() => {
      fetchDevices();
    });

    onBeforeUnmount(() => {
      clearInterval(checkStatusInterval.value);
    });

    // TRANSLATIONS
    const trans = {
      "actions.cancel": t("actions.cancel"),
      "messages.activate.title": t("messages.activate.title"),
      "messages.activate.confirm": t("messages.activate.confirm"),
      "messages.desactivate.title": t("messages.desactivate.title"),
      "messages.desactivate.confirm": t("messages.desactivate.confirm"),
      "messages.loading.title": t("messages.loading.title"),
      "messages.desactivate.error": t("messages.desactivate.error"),
      "messages.activate.error": t("messages.activate.error"),
      "messages.activate.activated_correctly": t("messages.activate.activated_correctly"),
      "messages.desactivate.desactivated_correctly": t(
        "messages.desactivate.desactivated_correctly"
      ),
      "messages.desactivate.desactivated_correctly_confirm": t(
        "messages.desactivate.desactivated_correctly_confirm"
      ),
      "messages.activate.activated_correctly_confirm": t(
        "messages.activate.activated_correctly_confirm"
      ),
      "bosch.panelOffline": t("bosch.panelOffline"),
      "bosch.armPanel": t("bosch.armPanel"),
      "bosch.disarmPanel": t("bosch.disarmPanel"),
      "bosch.arming": t("bosch.arming"),
      "bosch.disarming": t("bosch.disarming"),
      "bosch.syncDevices": t("bosch.syncDevices"),
      "bosch.syncing": t("bosch.syncing"),
      "bosch.syncCorrectly": t("bosch.syncCorrectly"),
      "bosch.devices": t("bosch.devices"),
      "messages.activate.armed_correctly": t("messages.activate.armed_correctly"),
      "messages.activate.armed_correctly_confirm": t(
        "messages.activate.armed_correctly_confirm"
      ),
      "messages.desactivate.disarmed_correctly": t(
        "messages.desactivate.disarmed_correctly"
      ),
      "messages.desactivate.disarmed_correctly_confirm": t(
        "messages.desactivate.disarmed_correctly"
      ),
      "messages.activate.activating": t("messages.activate.activating"),
      "messages.desactivate.deactivating": t("messages.desactivate.deactivating"),
      "messages.processing": t("messages.processing"),
      "bosch.messages.executeCommandConfirm": t("bosch.messages.executeCommandConfirm"),
      "bosch.messages.commandExecutedSuccess": t("bosch.messages.commandExecutedSuccess"),
      "bosch.messages.commandExecutedError": t("bosch.messages.commandExecutedError"),
      "bosch.messages.areYouSure": t("bosch.messages.areYouSure"),
      area: t("bosch.devices.area"),
      arm: t("bosch.devices.arm"),
      disarm: t("bosch.devices.disarm"),
      output: t("bosch.devices.output"),
      zone: t("bosch.devices.zone"),
      door: t("bosch.devices.door"),
      panel: t("bosch.devices.panel"),
      bypass: t("bosch.devices.bypass"),
      reset: t("bosch.devices.reset"),
      open: t("bosch.devices.open"),
      close: t("bosch.devices.close"),
      activate: t("bosch.devices.activate"),
      deactivate: t("bosch.devices.deactivate"),
    };

    // COMPUTED PROPERTIES
    const panelStatus = computed(() => {
      if (!panel.value.devices || !panel.value.devices.panel) return "offline";

      return panel.value.devices.panel.status || "offline";
    });

    const showPanel = computed(() => {
      if (!panel.value.devices || !panel.value.devices.panel) return false;
      if (!textFilter.value) return true;

      const search = textFilter.value.toLowerCase();
      const p = panel.value.devices.panel;
      return [p.device_id.toString(), p.text.toLowerCase()].some((value) =>
        value.includes(search)
      );
    });

    const filteredAreas = computed(() => {
      if (!panel.value.devices || !panel.value.devices.areas) return [];
      if (!textFilter.value) return panel.value.devices.areas;

      const search = textFilter.value.toLowerCase();

      return panel.value.devices.areas
        .map((area) => {
          const areaMatches = [area.device_id.toString(), area.text.toLowerCase()].some(
            (value) => value.includes(search)
          );

          // If area name/id matches, show area with all its zones
          if (areaMatches) return area;

          // Otherwise filter only matching zones
          const matchingZones = (area.devices || []).filter((zone) =>
            [zone.device_id.toString(), zone.text.toLowerCase()].some((value) =>
              value.includes(search)
            )
          );

          if (matchingZones.length > 0) {
            return { ...area, devices: matchingZones };
          }

          return null;
        })
        .filter(Boolean);
    });

    // Auto-expand areas that have search results
    watch(textFilter, (newVal) => {
      if (newVal) {
        expandedAreas.value = filteredAreas.value.map((area) => area.id);
      } else {
        expandedAreas.value = [];
      }
    });

    const filteredOutputs = computed(() => {
      if (!panel.value.devices || !panel.value.devices.outputs) return [];
      if (!textFilter.value) return panel.value.devices.outputs;

      return panel.value.devices.outputs.filter((output) =>
        [output.device_id.toString(), output.text.toLowerCase()].some((value) =>
          value.includes(textFilter.value.toLowerCase())
        )
      );
    });

    const filteredDoors = computed(() => {
      if (!panel.value.devices || !panel.value.devices.doors) return [];
      if (!textFilter.value) return panel.value.devices.doors;

      return panel.value.devices.doors.filter((door) =>
        [door.device_id.toString(), door.text.toLowerCase()].some((value) =>
          value.includes(textFilter.value.toLowerCase())
        )
      );
    });

    const isDark = computed(() => store.state.appConfig.layout.skin === "dark");

    const styleStatusPanel = computed(() => {
      const status = panelStatus.value;
      let color = "orange";

      if (status === "ONLINE") color = "green";
      else if (status === "OFFLINE") color = "red";

      return {
        background: color,
        width: "1rem",
        height: "1rem",
        borderRadius: "1rem",
        textAlign: "center",
        margin: "0 5px",
      };
    });

    const textStatusPanel = computed(() => {
      const status = panelStatus.value;
      const statusMap = {
        "ONLINE": t("bosch.panelStatusOnline"),
        "OFFLINE": t("bosch.panelStatusOffline"),
        "ARMED": t("bosch.panelStatusArmed"),
        "DISARMED": t("bosch.panelStatusDisarmed")
      };
      return statusMap[status] || status;
    });

    // METHODS
    async function fetchDevices() {
      try {
        const {id} = router.currentRoute.params;
        const panelId = id || props.panelId;
        const response = await store.dispatch("bosch_panels/show", panelId);
        panel.value = response.data;
        console.log(panel.value);
      } catch {
        panel.value = {};
      }
    }

    async function syncDevices() {
      loading.value = true;
      loadingToast.value.show(
        trans["bosch.syncDevices"],
        trans["bosch.syncing"],
        "secondary"
      );

      try {
        await store.dispatch("bosch_panels/syncDevices", panel.value.id);
        await fetchDevices();
        toast({
          component: ToastificationContent,
          props: {
            title: `${trans["bosch.syncCorrectly"]}`,
            icon: "CheckIcon",
            variant: "success",
          },
        });
      } catch (error) {
        await fetchDevices();
        const errorMessage = error.response?.data?.message || error.message;
        toast({
          component: ToastificationContent,
          props: {
            title: errorMessage,
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      } finally {
        loading.value = false;
        loadingToast.value.close();
      }
    }

    async function updateStatus() {
      // loading.value = true;
      // await syncDevices();
      // loading.value = false;
    }

    const toggleArea = (areaId) => {
      const index = expandedAreas.value.indexOf(areaId);
      if (index > -1) {
        expandedAreas.value.splice(index, 1);
      } else {
        expandedAreas.value.push(areaId);
      }
    };

    const getStatusClass = (status, deviceType = null) => {
      if (deviceType === "panel") {
        if (status === "OFFLINE") {
          return "badge badge-secondary"; // Gris/negro para offline
        } else if (status === "ONLINE") {
          return "badge badge-success";   // Verde para online
        }
        return "badge badge-info";        // Azul por defecto
      }

      const statusClasses = {
        // Estados activos/armados/online - Verde
        "ARMED": "badge badge-success",
        "ACTIVE": "badge badge-success",
        "LOCKED": "badge badge-success",
        "SECURED": "badge badge-success",
        "ONLINE": "badge badge-success",
        "All On Instant Armed": "badge badge-success",

        // Estados inactivos/desarmados/offline - Gris/Negro
        "DISARMED": "badge badge-secondary",
        "INACTIVE": "badge badge-secondary",
        "UNLOCKED": "badge badge-secondary",
        "OFFLINE": "badge badge-secondary",
        "bypassed": "badge badge-secondary",

        // Estados normales/informativos - Azul
        "NORMAL": "badge badge-info",
        "active (Not Bypassed)": "badge badge-info",
        "UNKNOWN": "badge badge-info",

        // Estados de advertencia - Amarillo
        "forced": "badge badge-warning",
      };

      return statusClasses[status] || "badge badge-info"; // Azul por defecto
    };

    const vm = getCurrentInstance();
    const proxy = vm.root.proxy;

    const goBack = () => {
      const routeParts = proxy.$route.path.split("/");
      const path = `${routeParts[1]}/${routeParts[2]}`;
      proxy.$router.push(`/${path}`);
    };

    return {
      loading,
      panel,
      bTable,
      textFilter,
      syncDevices,
      loadingToast,
      styleStatusPanel,
      textStatusPanel,
      panelStatus,
      updateStatus,
      refreshTimeout,
      trans,
      isDark,
      goBack,
      expandedAreas,
      toggleArea,
      getStatusClass,
      filteredAreas,
      filteredOutputs,
      filteredDoors,
      showPanel,
    };
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables/_variables.scss";

.test-scss-variables-container {
  background-color: $accent-custom-color;
  color: $theme-dark-headings-color;
  padding: 1rem;
  border-radius: 0.25rem;
  margin-bottom: 1rem;
}

.table-fields-devices {
  border-top: 1px solid #ebe9f1;
  border-bottom: 1px solid #ebe9f1;
  background-color: #f3f2f7;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  width: 100%;

  .dark-layout & {
    background-color: $theme-dark-table-header-bg;
    border-color: var(--third-dark);
  }
}

.table-title {
  color: #6e6b7b;
  font-size: 0.857rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  font-weight: 700;

  .dark-layout & {
    color: $theme-dark-headings-color;
  }
}

.device-row {
  border: 1px solid #ebe9f1;
  margin-bottom: 1px;
  width: 100%;

  .dark-layout & {
    background-color: var(--second-dark);
    color: $theme-dark-label-color;
  }
}

.device-row:hover {
  background-color: #f8f9fa;

  .dark-layout & {
    background-color: darken($second-dark, 5%);
  }
}

.area-header {
  background-color: #f3f2f7;
  border: 1px solid #d8d6de;
  transition: all 0.3s ease;
  overflow: visible !important;

  .dark-layout & {
    background-color: $theme-dark-table-row-bg;
    border-color: var(--third-dark);
  }
}

.area-header:hover {
  background-color: #e7e7e7;
  border-color: #c2bfc7;

  .dark-layout & {
    background-color: $theme-dark-table-hover-bg;
    border-color: var(--third-dark);
  }
}

.area-expanded {
  border-bottom-color: #6e6b7b !important;
  background-color: #e7e7e7;
}

.area-accordion {
  border-radius: 4px;
  overflow: visible !important;
  width: 100%;
}

.area-content {
  background-color: #fafafa;
}

.zones-container {
  border-left: 3px solid #d8d6de;
  padding-left: 1rem;
}

.zone-row {
  background-color: #fff;
  margin-left: 0;
}

.zone-row:last-child {
  border-bottom: none;
}

.transition-all {
  transition: all 0.2s ease;
}

.cursor-pointer {
  cursor: pointer;
}

.badge {
  font-size: 0.75rem;
  padding: 0.375rem 0.75rem;
}
</style>
